import ComponentSettingsNotAvailable from './ComponentSettingsNotAvailable';
export default ComponentSettingsNotAvailable;